

















import { mdiPlay, mdiRestore } from "@mdi/js";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "BottomNavigation",
})
export default class BottomNavigation extends Vue {
  tryAgainIcon = mdiRestore;
  playIcon = mdiPlay;

  @Prop({ default: () => true }) showPlayBtn!: boolean;
  @Prop({ default: () => true }) showTryAgainBtn!: boolean;
}
